module.exports = __webpack_public_path__ + "static/media/coin_img.f0f5b793.png";